// API
import { API, windowScroll } from "../Global/Actions";



export function getOptions(){
    return (dispatch) => {
        API('get-perfiles').then((res) => {
            dispatch({
                type 	: "MERGE-PERFILES-STATES",
                payload	: {
                    "options" : res
                }
            });
        });
    }
}



export function toggleOption(opt){
    return (dispatch) => {
        dispatch({
            type 	: "MERGE-PERFILES-STATES",
            payload	: {
                "selected" : opt
            }
        });

        windowScroll((document.getElementById('step-3').offsetTop - 40), 0);
    }
}